import AuthService from "../../services/AuthService";
import { Pagination, Tokens } from "../../Interfaces/Interfaces";
import AggregatorService from "../../services/AggregatorService";
import POSService from "../../services/PosService";
import { decode } from "jsonwebtoken";
import { errorHandler } from "../../helpers/Functions";
import CoordinatorService from "../../services/CoordinatorService";
import { useDispatch } from "react-redux";

// import { getCurrentUser } from "./CoordinatorActions";

export const getToken = (state: any) => {
  const api = new AuthService().getToken(state);

  return (dispatch: any) => {
    api
      .then((res: Tokens) => {
        if (res.access_token) {
          // set authentication to true
          dispatch({
            type: "AUTH_TOKEN",
            payload: { access_token: res.access_token },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      });
  };
};

export const getAggregatorUser = () => {
  const api = new AggregatorService().getCurrentUser();

  return (dispatch: any) => {
    api
      .then((res: any) => {
        console.log({ res });
        if (res.successful) {
          dispatch({
            type: "USER",
            payload: res.result,
          });
          localStorage.setItem("aggregator", JSON.stringify(res.result));
          if (!res.result.passwordChanged) {
            localStorage.setItem("passwordChanged", "false");
            window.location.pathname = "/account/update-password";
          } else {
            window.location.pathname = "/dashboard";
            dispatch({
              type: "ALERT",
              payload: {
                successful: true,
                message: "Logged in",
              },
            });
          }
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: "Invalid credentials",
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAggregatorAdminUser = () => {
  const api = new AggregatorService().getCurrentUser();

  return (dispatch: any) => {
    api
      .then((res: any) => {
        console.log({ res });
        if (res.successful) {
          dispatch({
            type: "USER",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: "Invalid credentials",
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getUserDetails = (state: any) => {
  const api = new AggregatorService().getUser(state);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "USER",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAggregatorDetails = (state: any) => {
  const api = new AggregatorService().getAggregatorDetails(state);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "SALES_REP",
            payload: res.result.contacts,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: "Invalid credentials",
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const login = (state: any) => {
  const api = new AuthService().login(state);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.access_token) {
          // persist userType
          const user = handleToken(res.access_token);
          sessionStorage.setItem("userType", JSON.stringify(user.user_type));

          dispatch({
            type: "USER_TYPE",
            payload: user.user_type,
          });

          // set authentication to true
          sessionStorage.setItem("auth", "true");

          dispatch({
            type: "AUTH_TOKEN",
            payload: { access_token: res.access_token },
          });

          dispatch({
            type: "ALERT",
            payload: {
              successful: true,
              message: "Login successful",
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: res.error_description,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const changePassword = (state: any) => {
  const api = new AuthService().changePassword(state);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          // set authentication to true
          dispatch({
            type: "ALERT",
            payload: {
              successful: true,
              message: "Success",
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: "Invalid credentials",
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const createPin = (state: any) => {
  const api = new AggregatorService().createPin(state);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          // set authentication to true
          dispatch({
            type: "ALERT",
            payload: {
              successful: true,
              message: "Success",
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const createAdminUserPin = (state: any) => {
  const api = new AggregatorService().createAdminUserPin(state);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          // set authentication to true
          dispatch({
            type: "ALERT",
            payload: {
              successful: true,
              message: "Success",
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
//createAdminUserPin
export const createAccount = (data: any) => {
  const api = new AggregatorService().createCahoutAccount(data);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          // set authentication to true
          dispatch({
            type: "ALERT",
            payload: {
              successful: true,
              message: "Success",
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const changePin = (state: any) => {
  const api = new AggregatorService().changePin(state);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          // set authentication to true
          dispatch({
            type: "ALERT",
            payload: {
              successful: true,
              message: "Success",
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: "Invalid credentials",
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const forgotPassword = (state: any) => {
  const api = new AuthService().forgotPassword(state);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          // set authentication to true
          dispatch({
            type: "ALERT",
            payload: {
              successful: true,
              message: "Recovery mail sent",
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: "Invalid credentials",
            },
          });
        }
      })
      .catch((err: any) => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: `Network request failed. Error => ${err}`,
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const resetPassword = (state: any) => {
  const api = new AuthService().resetPassword(state);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          // set authentication to true
          dispatch({
            type: "ALERT",
            payload: {
              successful: true,
              message: "Password reset successfully",
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAggregatorDashboard = () => {
  const api = new AggregatorService().getDashboard();

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "DASHBOARD",
            payload: res.result,
          });
        } else {
          // dispatch({
          //   type: "ALERT",
          //   payload: {
          //     successful: false,
          //     message: errorHandler(res),
          //   },
          // });
          dispatch({
            type: "DASHBOARD",
            payload: {},
          });
        }
      })
      .catch(() => {
        // send err to application
        // dispatch({
        //   type: "ALERT",
        //   payload: {
        //     message: "",//"Network request failed",
        //     successful: false,
        //   },
        // });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const getCordinatorDashboard = () => {
  const api = new CoordinatorService().getCoordinatorCommissionDashboard();

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "DASHBOARD",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        // dispatch({
        //   type: "ALERT",
        //   payload: {
        //     message: "",//"Network request failed",
        //     successful: false,
        //   },
        // });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const getPOSDashboard = (id: string) => {
  const api = new POSService().getDashboard(id);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "DASHBOARD",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAggregatorCommission = (data: Pagination) => {
  const api = new AggregatorService().getAggregatorCommission(data);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "COMMISSIONS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getCashoutAccount = (id: string) => {
  const api = new AggregatorService().getCashoutAccount(id);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "CASHOUT",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const withdrawToWallet = (data: any) => {
  const api = new AggregatorService().withdrawToWallet(data);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const withdrawToBank = (data: any) => {
  const api = new AggregatorService().withdrawToBank(data);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const withdrawFromCommissionToWallet = (data: any) => {
  const api = new AggregatorService().withdrawFromCommissionToWallet(data);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const withdrawalFromWalletToOtherBank = (data: any) => {
  const api = new AggregatorService().withdrawalFromWalletToOtherBank(data);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const sendOTP = (data: any) => {
  const api = new AuthService().sendOTP(data);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "OTP sent Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const confirmEmail = (data: any) => {
  const api = new AuthService().confirmEmail(data);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "CONFIRM_EMAIL",
            payload: {
              message: "Email Verification Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const resendConfirmationLink = (data: any) => {
  const api = new AuthService().resendConfirmationLink(data);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Email confirmation sent.",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};


export const sendOtpToUser = (data: any) => {
  const api = new POSService().sendOtp(data);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          console.log(res);
          
          dispatch({
            type: "OTP",
            payload: res.result
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const verifyUserOtp = (data: any) => {
  const api = new POSService().verifyOtp(data);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "VERIFYOTP",
            payload: res.result
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

// export const activateAndDeactivateAdminAction = (data: any) => {
//   const api = new AuthService().activateAndDeactivateAdminService(data);

// return (dispatch: any) => {
// api
//   .then((res: any) => {
//     if (res.successful) {
//       dispatch({
//         type: "ALERT",
//         payload: {
//           message: "Email confirmation sent.",
//           successful: true,
//         },
//       });
//     } else {
//       dispatch({
//         type: "ALERT",
//         payload: {
//           successful: false,
//           message: errorHandler(res),
//         },
//       });
//     }
//   })
//   .catch(() => {
//     // send err to application
//     dispatch({
//       type: "ALERT",
//       payload: {
//         message: "", //"Network request failed",
//         successful: false,
//       },
//     });
//   })
//   .finally(() => {
//     dispatch({
//       type: "LOADING",
//       payload: false,
//     });
//   });
// };
// };

const handleToken = (access_token: string) => {
  const decoded: any = decode(access_token);
  return decoded;
};
